import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CurrentDateTime from "../CurrentDateTime";

function CancelScreen() {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const { encryptPayload } = require("../../utils/custom-hash");
  // const [errors, setErrors] = useState({});

  const handleSubmit = async () => {
    try {
      const payload = {
        referenceCode: appointmentDetails.referenceCode,
        name: appointmentDetails.name,
        email: appointmentDetails.email,
        contact: appointmentDetails.contactNumber,
        mobile: appointmentDetails.contactNumber,
        serviceName: appointmentDetails.serviceName,
        branchName: appointmentDetails.branchName,
        scheduledOn: formattedDate,
        timeStart: formattedTimeStart
      };
    

      const response = await fetch(`${process.env.REACT_APP_ASERVER}/api/appointment/cancel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          encryptedPayload: encryptPayload(payload),
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      // const data = await response.json();
      navigate('/online-appointment/cancellation');
    } catch (error) {
      alert("Error fetching services: " + error.message);
    }
  };


  const handleCancel = () => {
    navigate("/online-appointment/ticket-details", {
      state: { responseData: responseData },
    });
  };

  const responseData = state && state.responseData;
  


  // Extract appointment details if responseData exists
  const appointmentDetails = responseData ? responseData : {};
 


  const renderAppointmentDetails = appointmentDetails && (
    <ul>
      <li>Date: {appointmentDetails.appointment_date}</li>
      <li>Email: {appointmentDetails.email}</li>
      <li>Name: {appointmentDetails.name}</li>
      <li>Branch: {appointmentDetails.branchName}</li>
      <li>Service: {appointmentDetails.serviceName}</li>
      <li>Reference Number: {appointmentDetails.referenceNumber}</li>
      <li>Start Time: {appointmentDetails.start_time}</li>
      <li>End Time: {appointmentDetails.end_time}</li>
    </ul>
  );
  // Format the appointment date and time
  const formattedDate = appointmentDetails && new Date(appointmentDetails.scheduledOn).toLocaleDateString();
  const formattedTimeStart = appointmentDetails && appointmentDetails.timeStart.slice(0, 5);
  const formattedTimeEnd = appointmentDetails && appointmentDetails.timeEnd.slice(0, 5);
  return (
    <>
      <section
        className="d-table w-100"
        id="home"
        style={{
          backgroundImage: `url(/assets/images/bookonline-bg.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          backgroundAttachment: 'fixed',
          paddingTop: '10px'
        }}
      >
        <CurrentDateTime />
        <div className="container">
          <div className="row justify-content-center mt-5">
            <div className="col-md-5"></div>
            <div className="col-12 col-md-7">
              <div className="card rounded text-center" style={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                border: '1px solid #424242',
                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(184, 184, 184, 0.5) 2px 2px 32px 2px'
              }}>
                <h1 className="sub-title mb-2 mt-4 text-black">Cancel Appointment</h1>
                <p className="para-desc mx-auto" style={{ color: "#000" }}>
                  Are you sure you want to cancel your scheduled appointment?
                </p>
                <h5 style={{ color: "#396cf0" }}>Appointment Details</h5>
                <nav aria-label="breadcrumb" className="d-inline-block mt-2 mb-2 text-start">
                  <ul className="breadcrumb bg-transparent">

                    <li className='mb-1' style={{ color: "#396cf0", fontWeight: "bold" }}>Name: <span style={{ color: "#000", fontWeight: "100" }}>{appointmentDetails.name}</span> </li>
                    <hr style={{ borderColor: '#828282' }} />
                    <li className='mb-1' style={{ color: "#396cf0", fontWeight: "bold" }}>Branch:  <span style={{ color: "#000", fontWeight: "100" }}>{appointmentDetails.branchName}</span></li>
                    <hr style={{ borderColor: '#828282' }} />
                    <li className='mb-1' style={{ color: "#396cf0", fontWeight: "bold" }}>Service:  <span style={{ color: "#000", fontWeight: "100" }}>{appointmentDetails.serviceName}</span></li>
                    <hr style={{ height: 0.1, borderColor: '#828282' }} />
                    <li className='mb-1' style={{ color: "#396cf0", fontWeight: "bold" }}>  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16">
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>&nbsp; {formattedDate}&nbsp;&nbsp;&nbsp;
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16">
                        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                      </svg>&nbsp;{formattedTimeStart} - {formattedTimeEnd}</li>
                    <hr style={{ height: 0.1, borderColor: '#828282' }} />
                    <li className='mb-1' style={{ color: "#000" }}>
                      Please confirm if you wish to proceed with the cancellation.
                    </li>
                  </ul>
                  <div className="d-flex justify-content-center mb-4">
                    <button
                      type="button"
                      className="btn btn-secondary me-3"
                      onClick={handleCancel}
                    >
                      Go back
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                    >
                      Confirm
                    </button>
                  </div>
                </nav>




              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CancelScreen;
